import { useQuery } from '@tanstack/react-query';

import { getDiasEmployees, type GetDiasEmployeesResponse } from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';
import type { QueryOptions } from '@/types/react-query';

import queryKeys from '../queryKeys';

export default function useAnvaEmployees(
  options?: QueryOptions<GetDiasEmployeesResponse['items']>,
) {
  return useQuery({
    queryKey: queryKeys.employees.list('dias', undefined),
    queryFn: async () => {
      const result = await getDiasEmployees({}, wgApi);

      return result.items;
    },
    ...options,
  });
}
